import { MainModel } from "./main-model";
import { Category } from "./category";
import { ModifierGroup } from "./modifier-group";
import { OrderType } from "./order-type";
import { RoutingTag } from "./routing-tag";
import { Site } from "./site";
import { Vat } from "./vat";
import { ProductCategoryDisplay } from "./product-category-display";
import { Course } from "./course";
import { AdjustmentItemType } from "./adjustment";
import { ProductComboSet } from "./combo-set";
import { TaxGroup } from "./tax-group";

export interface Product extends MainModel {
    receiptName: string;
    orderingName: string;
    displayName: string;
    description: string;
    price: number;
    costPrice: number;
    grossProfit: number;
    grossProfitMargin: number;
    grossProfitClass: string;
    priceOverride: boolean;
    promptForPrice: boolean;
    promptForUnit: boolean;
    excludeFromReceipt: boolean;
    defaultStatus: DefaultStatus;
    promptForAgeVerification: boolean;
    isActive: boolean;
    index: number;
    sellOnPOS: boolean;
    isComboDeal: boolean;
    productComboSets: ProductComboSet[];
    isPriceByBOGOF: boolean;
    plu: number;
    unitID: number;
    productCategory: Category;
    vatRate: Vat;
    inheritedVatRate: Vat;
    productDisplay: ProductCategoryDisplay;
    inheritedDisplay: ProductCategoryDisplay;
    modifierGroups: ModifierGroup[];
    inheritedModifierGroups: ModifierGroup[];
    displayOnlyCategories: Category[];
    orderTypes: OrderType[];
    inheritedOrderTypes: OrderType[];
    productModifierModifierGroups: ModifierGroup[];
    routeTags: RoutingTag[];
    inheritedRouteTags: RoutingTag[];
    regionProducts: Site[];
    siteProducts: SiteProduct[];
    kdsID: number;
    kdsCookTime: number;
    kdsIsPercent: boolean;
    kdsNewTime: number;
    kdsRushTime: number;
    course: Course;
    inheritedCourse: Course;
    isCourseInherited: boolean;
    imageUrl: string;
    isIncluded: boolean;
    type: AdjustmentItemType;
    productStockCount: ProductStockCount;
    unitQuantity: number;
    stagingProductID: string;
}

export interface ProductStockCount {
    id: string;
    productId: string;
    siteId: string;
    remainingStockCount: number;
    IsDeleted: boolean;
}

export interface SiteProduct {
    id: string;
    isActive: boolean;
    price: number;
    site: Site;
    product?: Product;
    siteProductOrderTypes: SiteProductOrderType[];
    taxRateID: string;
    langReceiptName: string;
    siteProductTaxGroup: SiteTaxGroup | null;
}

export interface AboveProduct {
    isIncluded: boolean;
    product: Product;
}

export interface SiteTaxGroup {
    taxGroup: TaxGroup;
    isInherited: boolean;
}

export interface SiteProductOrderType {
    id: string;
    isActive: boolean;
    orderType: OrderType;
    price: number;
    taxRateID: string;
}

export enum DefaultStatus {
  OPEN = 1,
  PROCESSING = 2,
  CANCELLED = 3,
  LOCKED = 4,
  ONHOLD = 5,
  REFUSED = 6,
  PROCESSED = 7
}
